import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts'

interface PatientsDistributionProps {
  data?: Array<{
    status: string
    count: number
  }>
  isLoading?: boolean
}

const statusLabels: Record<string, string> = {
  active: 'Ativos',
  inactive: 'Inativos',
  discharged: 'Alta',
  archived: 'Arquivados',
}

const statusColors: Record<string, string> = {
  active: 'hsl(142, 76%, 36%)',
  inactive: 'hsl(45, 93%, 47%)',
  discharged: 'hsl(210, 70%, 50%)',
  archived: 'hsl(0, 0%, 60%)',
}

export function PatientsDistribution({ data, isLoading }: PatientsDistributionProps) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-[250px] w-full" />
        </CardContent>
      </Card>
    )
  }

  const chartData = (data ?? []).filter((item) => item.status !== 'deleted').map((item) => ({
    name: statusLabels[item.status] ?? item.status,
    value: item.count,
    color: statusColors[item.status] ?? 'hsl(0, 0%, 50%)',
  }))

  const total = chartData.reduce((sum, item) => sum + item.value, 0)

  return (
    <Card>
      <CardHeader>
        <CardTitle>Distribuição de Pacientes</CardTitle>
        <p className="text-sm text-muted-foreground">
          Total: {total} pacientes
        </p>
      </CardHeader>
      <CardContent>
        {chartData.length > 0 ? (
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={chartData}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                paddingAngle={5}
                dataKey="value"
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  backgroundColor: 'hsl(var(--background))',
                  border: '1px solid hsl(var(--border))',
                  borderRadius: '6px',
                }}
              />
              <Legend />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <div className="h-[250px] flex items-center justify-center text-muted-foreground">
            Nenhum dado disponível
          </div>
        )}
      </CardContent>
    </Card>
  )
}
